import React from 'react'
import { StyledRadioDot, StyledRadioDotInner } from './IconRadio.styled'

export interface IconRadioProps {
    id: string
    size: number
    checked: boolean
}

export const IconRadio = ({ id, size, checked }: IconRadioProps) => {
    return (
        <StyledRadioDot id={id} checked={checked} size={size}>
            <StyledRadioDotInner size={size} checked={checked} />
        </StyledRadioDot>
    )
}
